<template>
    <div id="student-dashboard" class="container my-5 pb-5">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12 col-lg-4 mb-4">
                        <student-profile :user="user"></student-profile>
                    </div>
                    <div class="col-12 col-lg-8 mb-4">
                        <student-status :assignedCounsellor="assignedCounsellor" @refreshData="refreshData">
                        </student-status>
                        <student-notification :notificationsData="notificationsData"></student-notification>
                    </div>
                </div>
            </div>
            <div v-if="triageData" class="col-12">
                <student-triage :triageData="triageData"></student-triage>
            </div>
        </div>
    </div>
</template>

<script>
import StudentNotification from '../../components/Student/Dashboard/Notification.vue';
import StudentProfile from '../../components/Student/Dashboard/Profile.vue'
import StudentStatus from '../../components/Student/Dashboard/Status.vue'
import StudentTriage from '../../components/Student/Dashboard/Triage.vue'

export default {
    name: 'student-dashboard',
    components: {
        StudentNotification,
        StudentProfile,
        StudentStatus,
        StudentTriage
    },
    props: {
        assignedCounsellor: {
            required: true,
            type: Object
        },
        notificationsData: {
            required: true,
            type: Array
        },
        triageData: {
            required: true,
            type: Object
        },
        user: {
            required: true,
            type: Object
        }
    },
    methods: {
        refreshData() {
            this.$emit('refreshData');
        }
    }
}
</script>